export default function IsIFrame(): boolean {
    return window.location !== window.parent.location;
}
